import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getPostRouterLink} from "root/Wieldy/routePaths";
import GlobalContext, {useGlobalContext} from "root/contexts/GlobalContext";
import {PostMenus, getPostMenuTypeForUser} from "root/DataFunctions/PageContentRoles";
import {PostFilters, UserTypes} from "root/DataFunctions/Constants";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {MessageType} from "root/DataFunctions/Constants";
import {useRecoilValue} from "recoil";
import {returnedPostCountAtom} from "root/recoil/returnedPostCount";
import phpVars from 'phpVars';

const PostsSubmenu = (props ) =>
{
    const { userType } = useGlobalContext() ;

    const menuType = getPostMenuTypeForUser ( userType ) ;
    const adultPost = userType !== UserTypes.CHILD;

    const getReturnedPostCount = () =>
    {
        let returnedPostCount = useRecoilValue(returnedPostCountAtom);
        returnedPostCount = returnedPostCount === 0 ? '' : returnedPostCount;
        return returnedPostCount;
    }

    // Open add post modal
    const [renderAddPostModal, showAddPostModal] = useModalAddPost((result) =>
    {
    })

    const clickHandler = (event) =>
    {
        showAddPostModal('create', null, null, adultPost, MessageType.MESSAGE_TYPE_LIFESTORY);
    }

    const managerPostSubmenu =() =>{
        return(
            <AppSidebarGroup title='Filters' default={PostFilters.NEW}>
                {/*<AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.PENDING)} title='To Approve' iconName='icon-important' name={PostFilters.PENDING} />*/}
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.NEW)} title='Submitted' iconName='icon-draft' name={PostFilters.NEW}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.DRAFT)} title='My Drafts' iconName='icon-edit' name={PostFilters.DRAFT}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.DISCUSSING)} title='Returned' iconName='icon-question-circle'
                                    name={PostFilters.DISCUSSING} count = {getReturnedPostCount()}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.HELD)} title='Held' iconName='icon-forgot-password' name={PostFilters.HELD}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.APPROVED)} title='Approved' iconName='icon-thumb-up' name={PostFilters.APPROVED}/>

                <WieldySidebarSection title='New Post' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Post' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>
            </AppSidebarGroup>
        )
    }

    const contributorPostSubmenu =() =>{

        return(
            <AppSidebarGroup title='Filters' default={PostFilters.NEW}>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.NEW)} title='Submitted' iconName='icon-draft' name={PostFilters.NEW} />
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.APPROVED)} title='Appoved' iconName='icon-thumb-up' name={PostFilters.APPROVED}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.DRAFT)} title='Drafts' iconName='icon-edit' name={PostFilters.DRAFT}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.DISCUSSING)} title='Returned' iconName='icon-question-circle'
                                    name={PostFilters.DISCUSSING} count = {getReturnedPostCount()}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.HELD)} title='Held' iconName='icon-forgot-password' name={PostFilters.HELD}/>

                <WieldySidebarSection title='New Post' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Post' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>
            </AppSidebarGroup>
        )
    }

    const childPostSubmenu =() =>{
        return(
            <AppSidebarGroup title='Filters' default={PostFilters.INCOMING}>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.INCOMING)} title='Inbox' iconName='icon-draft' name={PostFilters.INCOMING} />
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.SENT)} title='Sent' iconName='icon-thumb-up' name={PostFilters.SENT}/>
                <AppSidebarMenuItem link={getPostRouterLink('posts?type=' + PostFilters.DRAFT)} title='Drafts' iconName='icon-edit' name={PostFilters.DRAFT}/>

                <WieldySidebarSection title='New Post' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Post' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>
            </AppSidebarGroup>
        )
    }

    const menuSection = ( menuType ) =>
    {
        switch ( menuType )
        {
            case PostMenus.MANAGER:
                return managerPostSubmenu() ;
            case PostMenus.CONTRIBUTOR:
                return contributorPostSubmenu();
            case PostMenus.CHILD:
                return childPostSubmenu();
            default:
                throw new Error ( "Invalid Menu Type") ;
        }
    }

    return (
        <Fragment>
            { menuSection ( menuType )}
            {renderAddPostModal()}
        </Fragment>
    )
}

export default PostsSubmenu ;